module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Once-Upon-A-Time-In-Venice.6a050a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Once-Upon-A-Time-In-Venice.jpg
// module id = O5m6
// module chunks = 0